import { Box, Skeleton } from '@mui/material';
import { FC, useState } from 'react';
import { useEventBus } from '../../../../hooks/use-event-bus';
import { EventIvShowNoAppRequestInsuranceDialog } from '../../../../types/event-bus';
import { StatusText, StatusWrapper, UnknownVerificationStatus, VerificationInProcessStatus } from '../../shared/styles';

export interface UnknownIvStatusButtonProps {
  locationId: number;
  apptRequestId: number;
  isUnknown?: boolean;
}

export const UnknownIvStatusButton: FC<UnknownIvStatusButtonProps> = (props) => {
  const { locationId, apptRequestId, isUnknown } = props;
  const { publish } = useEventBus();
  const [isLoading, setIsLoading] = useState(false);

  const handlePatientFlowClick = () => {
    setIsLoading(true);

    publish({
      messageType: 'ivShowNoApptRequestInsuranceDialog',
      data: {
        apptRequestId,
        locationId,
        isUnknown
      }
    } as EventIvShowNoAppRequestInsuranceDialog);

    setTimeout(() => setIsLoading(false), 1000);
  };

  return (
    <>
      <StatusWrapper>
        {isUnknown ? <VerificationInProcessStatus /> : <UnknownVerificationStatus />}
        <Box sx={{ display: 'flex', flexDirection: 'column', marginLeft: '8px' }}>
          {isLoading ? (
            <Skeleton height={20} width={120} />
          ) : (
            <StatusText onClick={handlePatientFlowClick}>
              {isUnknown ? 'Unknown' : 'Verification In Process'}
            </StatusText>
          )}
        </Box>
      </StatusWrapper>
    </>
  );
};
